import * as React from "react";
import {useEffect, useState} from "react";
import {ApiService} from "../services/ApiService";
import {LoaderSpinner} from "./LoaderSpinner";
import {ApiResponse, getErrorMessagesFromResponse, getMessageText} from "../models/ApiResponse";
import "./read-button-list.css";
import {ReadButtonModel} from "../models/ReadButtonModel";
import {DATE_TIME_OPTIONS, timestampToString} from "../helpers/Date";

interface ReadButtonListProps {
}

export default function ReadButtonList(props: ReadButtonListProps) {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>('');
    const [readButtons, setReadButtons] = useState<ReadButtonModel[]>([]);
    const [tags, setTags] = useState<string[]>([]);
    const apiService: ApiService = new ApiService();
    const [tag, setTag] = useState<string>('');

    useEffect(() => {
        readButtonTags();
    }, []);

    const readButtonTags = () => {
        setLoading(true);
        setError('');

        apiService.post('read_button_tags', {}).then((apiResponse: ApiResponse) => {
            setLoading(false);
            setTags(apiResponse.response.data.tags);
        }).catch(reason => {
            console.log(reason);
            const msg = getMessageText(getErrorMessagesFromResponse(reason));
            setError(msg ? msg : 'Es ist ein unerwarteter Fehler aufgetreten');
            setLoading(false);
        });
    }

    const readButtonList = (tagValue: string) => {
        if (tagValue) {
            setLoading(true);
            setError('');

            apiService.post('read_button_list', {tag: tagValue}).then((apiResponse: ApiResponse) => {
                setLoading(false);
                setReadButtons(apiResponse.response.data.readButtons);
            }).catch(reason => {
                console.log(reason);
                const msg = getMessageText(getErrorMessagesFromResponse(reason));
                setError(msg ? msg : 'Es ist ein unerwarteter Fehler aufgetreten');
                setLoading(false);
            });
        } else {
            setReadButtons([]);
        }
    }

    return <div className={"read-button-list"}>
        <div className={"spacer"}/>
        {loading ? (
            <LoaderSpinner/>
        ) : (
            <>
                <div className={"tag"}>
                    <label>Tag: </label>
                    <select onChange={event => {
                        setTag(event.target.value);
                        readButtonList(event.target.value);
                    }} value={tag}>
                        <option value="">Auswählen</option>
                        {tags.map((tagValue, index) => {
                            return <option key={index} value={tagValue}>
                                {tagValue}
                            </option>
                        })}
                    </select>
                </div>

                <div className={"spacer"}/>

                {readButtons.length > 0 && (
                    <table>
                        <thead>
                        <tr>
                            <th>Benutzer</th>
                            <th>Zustimmung</th>
                        </tr>
                        </thead>
                        <tbody>
                        {readButtons.map((readButton: ReadButtonModel, index: number) => {
                            return <tr key={index}>
                                <td width={250}>
                                    {readButton.user}
                                </td>
                                <td width={300}>
                                    {readButton.timestamp ? timestampToString(readButton.timestamp * 1000, DATE_TIME_OPTIONS) : '-'}
                                </td>
                            </tr>;
                        })}
                        </tbody>
                    </table>
                )}
            </>
        )}

        {error && (
            <div className={"errorMessage"}>
                {error}
            </div>
        )}
    </div>;
}
